import PublicOnlyRoute from '../PublicOnlyRoute';

const PublicLayout = () => <PublicOnlyRoute />;

export default PublicLayout;
